import { BackendFeatureSelector } from "./BackendFeatureSelector";
import { BackendFlagSelector } from "./BackendFlagSelector";
import { FrontendFeatureSelector } from "./FrontendFeatureSelector";
import MockFlagSelector from "./RequestMockFlagSelector";

export function DebugSelectors() {
  return (
    <ul className="divide-y-1 divide-border">
      <li className="divide-y-1 divide-border-secondary">
        <FrontendFeatureSelector />
      </li>
      <li className="divide-y-1 divide-border-secondary">
        <BackendFeatureSelector />
      </li>
      <li className="divide-y-1 divide-border-secondary">
        <BackendFlagSelector />
      </li>
      <li className="divide-y-1 divide-border-secondary">
        <MockFlagSelector />
      </li>
    </ul>
  );
}
